import DynamicProviderKey from "@/model/provider/DynamicProviderKey"

const registry = {
    group: {},

    provider: {
        aff_standard: {
            paymentPlanContent: () => import("@/components/provider/aff/AffPaymentPlanContent.vue"),
            paymentPlanCost: () => import("@/components/provider/aff/AffPaymentPlanCost.vue"),
            paymentPlanOption: () => import("@/components/provider/aff/AffPaymentPlanOption.vue"),
        },
        fortiva_standard: {
            paymentPlanContent: () => import("@/components/provider/fortiva/FortivaPaymentPlanContent.vue"),
            paymentPlanCost: () => import("@/components/provider/fortiva/FortivaPaymentPlanCost.vue"),
            paymentPlanOption: () => import("@/components/provider/fortiva/FortivaPaymentPlanOption.vue"),
            paymentPlanDescription: () => import("@/components/provider/fortiva/FortivaPaymentPlanDescription.vue"),
            paymentPlanMonthlyPayment: () => import("@/components/provider/fortiva/FortivaPaymentPlanMonthlyPayment.vue"),
        },
        hfd_standard: {
            downpaymentSupportedAssociations: () =>
                import("@/components/provider/hfd/HfdDownpaymentSupportedAssociations.vue"),
            paymentPlanContent: () => import("@/components/provider/hfd/HfdPaymentPlanContent.vue"),
            paymentPlanCost: () => import("@/components/provider/hfd/HfdPaymentPlanCost.vue"),
            paymentPlanApprovalAmount: () => import("@/components/provider/hfd/HfdPaymentPlanApprovalAmount.vue"),
        },
        synchrony_standard: {
            paymentPlanOption: () => import("@/components/provider/synchrony/SynchronyPaymentPlanOption.vue"),
            paymentPlanContent: () => import("@/components/provider/synchrony/SynchronyPaymentPlanContent.vue"),
            paymentPlanCost: () => import("@/components/provider/synchrony/SynchronyPaymentPlanCost.vue"),
            paymentPlanDescription: () => import("@/components/provider/synchrony/SynchronyPaymentPlanDescription.vue"),
            existingAccountPlanOption: () =>
                import("@/components/provider/synchrony/SynchronyExistingAccountPlanOption.vue"),
            learnHowDrawer: () => import("@/components/provider/synchrony/SynchronyLearnHowDrawer.vue"),
        },
        proceed_standard: {
            paymentPlanContent: () => import("@/components/provider/proceed/ProceedPaymentPlanContent.vue"),
        },
        lendingclub_standard: {
            paymentPlanContent: () => import("@/components/provider/lendingclub/LendingClubPaymentPlanContent.vue"),
        },
    },
}

const cache = {}

function buildCacheKey(type, groupId, providerKey) {
    let key = type
    if (groupId) key += "." + groupId
    if (providerKey) key += "." + providerKey
    return key
}

export default {
    findComponent(type, groupId, providerKey) {
        if (!type) return null

        providerKey = DynamicProviderKey.extractProviderKey(providerKey)

        const cacheKey = buildCacheKey(type, groupId, providerKey)

        let component = cache[cacheKey]

        if (component) return component
        if (component === false) return null

        if (groupId && providerKey) {
            if (registry.group[groupId]?.provider[providerKey]?.[type]) {
                component = registry.group[groupId]?.provider[providerKey]?.[type]
            }
        }

        if (!component && groupId) {
            if (registry.group[groupId]?.[type]) {
                component = registry.group[groupId]?.[type]
            }
        }

        if (!component && providerKey) {
            if (registry.provider[providerKey]?.[type]) {
                component = registry.provider[providerKey]?.[type]
            }
        }

        cache[cacheKey] = component || false

        return component
    },
}
